import { useTranslation } from 'react-i18next';

import type { ProcrastinationSuggestion } from '../../../api/types';
import { Button } from '../../../shared/ui/Button';
import styles from './SuggestedTaskCard.module.css';

interface SuggestedTaskCardProps {
  suggestion: ProcrastinationSuggestion;
  // PARA-139 (AC-2/AC-3): блокировка кнопки «Done» на время pending и отображение ошибки смены статуса.
  isPending?: boolean;
  errorMessage?: string | null;
  onComplete: () => void;
  onAnother: () => void;
  onDismiss: () => void;
}

// PARA-105, AC-3: предложенная задача (выделенная карточка) + 3 действия.
// PARA-122 (D8, AC-8): overline — цветная точка размера + uppercase-мета; title
// 22px/600. Действия (✓/↻/✕) вынесены под карточку (образец
// components/tasks/SuggestedTaskCard.prompt.md), остаются нейтральными (без
// деструктивного варианта — тон «заботливый напарник», AC-3).
export function SuggestedTaskCard({
  suggestion,
  isPending = false,
  errorMessage = null,
  onComplete,
  onAnother,
  onDismiss,
}: SuggestedTaskCardProps): JSX.Element {
  const { t } = useTranslation('procrastination');
  const sizeClass = styles[suggestion.size.toLowerCase() as 'small' | 'medium' | 'big'];

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.card} ${sizeClass}`} data-testid="suggested-task-card">
        <div className={styles.overline}>
          <span className={styles.dot} />
          <span className={styles.meta}>{t(`suggested.sizeMeta.${suggestion.size}`)}</span>
        </div>
        <div className={styles.title}>{suggestion.title}</div>
      </div>
      <div className={styles.actions}>
        <Button variant="primary" disabled={isPending} aria-busy={isPending} onClick={onComplete}>
          {t('suggested.complete')}
        </Button>
        <Button variant="secondary" onClick={onAnother}>
          {t('suggested.another')}
        </Button>
        <Button variant="ghost" onClick={onDismiss}>
          {t('suggested.dismiss')}
        </Button>
      </div>
      {errorMessage !== null && (
        <p className={styles.error} role="alert">
          {errorMessage}
        </p>
      )}
    </div>
  );
}
